import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export interface TemplatePriceEntry {
  price_group_id: number;
  price_group_label?: string;
  fixed_course_amount?: number | null;
  per_participant_amount?: number | null;
}

export interface EventPriceTemplateItem {
  id: number;
  label: string;
  is_active?: boolean;
  sort_order?: number;
  prices?: TemplatePriceEntry[];
  extra_option_ids?: number[];
}

/**
 * Active course price templates for the add/edit-event tagbox.
 */
export function event_price_templates(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_price_templates',
    description: 'Organisationens aktive kursusprisskabeloner til event-formularen',
    execute: (params?: LoadDataParams): Observable<{ items: EventPriceTemplateItem[]; totalCount: number }> => {
      const search =
        (params as { searchQuery?: string } | undefined)?.searchQuery ??
        params?.queryParams?.['searchQuery'] ??
        params?.queryParams?.['search'] ??
        '';
      const priceGroupId = params?.queryParams?.['priceGroupId'] ?? '';

      const httpParams: Record<string, string> = { activeOnly: 'true' };
      if (search) {
        httpParams['search'] = String(search);
      }
      if (priceGroupId) {
        httpParams['priceGroupId'] = String(priceGroupId);
      }

      return service.http
        .get<{ items?: EventPriceTemplateItem[]; totalCount?: number }>(
          `${environment.apiUrl}/events/course-price-templates`,
          { params: httpParams }
        )
        .pipe(
          map((res) => ({
            items: (res?.items ?? []) as EventPriceTemplateItem[],
            totalCount: res?.totalCount ?? (res?.items?.length ?? 0),
          })),
          catchError((error) => {
            console.error('[event_price_templates datasource] Error fetching templates:', error);
            return of({ items: [], totalCount: 0 });
          })
        );
    },
  };
}
